import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import ATSnackbar from '../layout/ATSnackbar';
import { useState } from 'react';

const DhanTokenUpdate = ({ user }) => {
  const { register, handleSubmit } = useForm({
    defaultValues: {
      passwordOrToken: ''
    }
  });
  const [notification, setNotification] = useState({
    open: false,
    message: ''
  });

  const onSubmit = (data) => {
    fetch(`/algo-trading/api/dh-token`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': user?.credential,
      },
      body: JSON.stringify(data)
    }).then(r => {
      if (r.ok) {
        setNotification({ open: true, message: 'Dhan token updated successfully.' });
      } else {
        console.error('Failed to update Dhan token', r);
        setNotification({ open: true, message: 'Failed to update Dhan token' });
      }
    }).catch(error => {
      console.error('Error updating Dhan token:', error);
      setNotification({ open: true, message: 'Error updating Dhan token' + error });
    })
  }

  const setOpen = (open) => {
    setNotification(prev => ({ ...prev, open }));
  }

  return (
    <Grid container item spacing={2} gap={2} sx={{ backgroundColor: 'white' }}>
      <ATSnackbar open={notification.open} message={notification.message} setOpen={setOpen} severity={'info'} />
      <Grid item xs={12}>
        <Typography variant="h6">Update Dhan Token</Typography>
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', }}>
        <Grid container spacing={2} display='flex' alignItems='center'>
          <Grid item lg={8}>
            <TextField label="Enter Dhan Token" variant="outlined" fullWidth required {...register('passwordOrToken')} />
          </Grid>
          <Grid item>
            <Button type="submit" variant='contained'>Submit</Button>
          </Grid>
        </Grid>
      </form>
    </Grid >

  )
}

export default DhanTokenUpdate